namespace TabAurous {
    export interface HRRequest extends Serenity.ListRequest {
        SalaryPackageIds?: number[];
        EmployeeIds?: number[];
        CompanyId?: number;
        DepartmentId?: number;
        DesignationId?: number;
    }
}
